import { getLuminance } from 'polished';

export default function checkDarKMode(background) {
  return getLuminance(background) < 0.5;
}

const invert = color => 255 - parseInt(color, 10);

export function getInverseRgba(rgba) {
  const [r, g, b, a] = rgba.replace(/[^\d,]/g, '').split(','); // ["255", "51", "0", "1"]
  return `rgba(${[invert(r), invert(g), invert(b), a].join(',')})`; // format: rgba(255,255,255,1)
}
